import { wkblSpecialVideoInit } from 'redux/reducers/init';
import {
  addDownloadingGroupSpecial,
  changeWkblSpecialVideoAsc,
  changeWkblSpecialVideoPage,
  changeWkblSpecialVideoReturnCount,
  changeWkblSpecialVideoSort,
  clearWkblSpecialVideoList,
  removeDownloadingGroupSpecial,
  requestWkblSpecialVideoList,
  requestWkblSpecialVideoListFailure,
  requestWkblSpecialVideoListSuccess,
  updateDownloadingGroupSpecial,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const wkblSpecialVideo = createReducer(wkblSpecialVideoInit, {
  [requestWkblSpecialVideoList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestWkblSpecialVideoListSuccess.type]: (state, action) => {
    const { specialVideoList, pagination, returnCount } = action.payload;
    pagination.returnCount = returnCount;
    state.isLoading = false;
    state.specialVideoList = specialVideoList;
    state.pagination = pagination;
  },
  [requestWkblSpecialVideoListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.specialVideoList = [];
  },
  [clearWkblSpecialVideoList.type]: (state, action) => {
    state.specialVideoList = [];
  },
  [changeWkblSpecialVideoPage.type]: (state, action) => {
    const { pageNumber } = action.payload;
    state.searchCondition.page = pageNumber;
  },
  [changeWkblSpecialVideoSort.type]: (state, action) => {
    const { sort } = action.payload;
    state.searchCondition.sort = sort;
  },
  [changeWkblSpecialVideoAsc.type]: (state, action) => {
    const { asc } = action.payload;
    state.searchCondition.asc = asc;
  },
  [changeWkblSpecialVideoReturnCount.type]: (state, action) => {
    const { returnCount } = action.payload;
    state.searchCondition.retr = returnCount;
    state.searchCondition.page = 0; // ReturnCount 변경시 1페이지부터 다시 조회
  },

  // [addDownloadingGroupSpecial.type]: (state, action) => {
  //   const { id } = action.payload;
  //   state.downloadingGroup[id] = {
  //     isDownloading: true,
  //     percent: 0,
  //   };
  // },

  // [removeDownloadingGroupSpecial.type]: (state, action) => {
  //   const { id } = action.payload;
  //   delete state.downloadingGroup[id];
  // },

  // [updateDownloadingGroupSpecial.type]: (state, action) => {
  //   const { percent, id } = action.payload;
  //   state.downloadingGroup[id].percent = percent;
  // },
});

export default wkblSpecialVideo;
